var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 0C24.9174 0 27.7153 1.15892 29.7782 3.22182C31.8411 5.28473 33 8.08262 33 11C33 13.9174 31.8411 16.7153 29.7782 18.7782C27.7153 20.8411 24.9174 22 22 22C19.0826 22 16.2847 20.8411 14.2218 18.7782C12.1589 16.7153 11 13.9174 11 11C11 8.08262 12.1589 5.28473 14.2218 3.22182C16.2847 1.15892 19.0826 0 22 0ZM18.1109 7.11091C19.1424 6.07946 20.5413 5.5 22 5.5C23.4587 5.5 24.8576 6.07946 25.8891 7.11091C26.9205 8.14236 27.5 9.54131 27.5 11C27.5 12.4587 26.9205 13.8576 25.8891 14.8891C24.8576 15.9205 23.4587 16.5 22 16.5C20.5413 16.5 19.1424 15.9205 18.1109 14.8891C17.0795 13.8576 16.5 12.4587 16.5 11C16.5 9.54131 17.0795 8.14236 18.1109 7.11091Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24.75C29.3425 24.75 44 28.4075 44 35.75V44H38.775V35.75C38.775 33.99 30.1675 29.975 22 29.975C13.8325 29.975 5.225 33.99 5.225 35.75V44H0V35.75C0 28.4075 14.6575 24.75 22 24.75Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d8874af56481c0393aa5ba10c4a81fb3.svg";
export { ForwardRef as ReactComponent };